import { RadioGroup, Radio, RadioGroupProps, RadioProps } from "@heroui/react";
import { Controller, useFormContext } from "react-hook-form";

export const CustomRadio = (props: RadioProps) => {
    const { children, ...otherProps } = props;

    return (
        <Radio
            {...otherProps}
            classNames={{
                base: "data-[selected=true]:border-primary p-1 max-w-screen flex-1 m-0 bg-gray-100  cursor-pointer rounded-lg border-2 border-gray-100 data-[selected=true]:font-semibold",
                label: "whitespace-nowrap overflow-hidden text-ellipsis",
            }}
        >
            {children}
        </Radio>
    );
};

function SelectButtonInput({
    name,
    options,
    radioProps,
    ...props
}: {
    name: string;
    options: {
        description: string;
        id: string | number | boolean;
        isDisabled?: boolean;
        icon?: React.ReactNode;
    }[];
    radioProps?: Partial<RadioProps>;
} & RadioGroupProps) {
    const f = useFormContext();
    return (
        <Controller
            name={name}
            control={f.control}
            render={({
                field: { onChange, value, onBlur },
                fieldState: { error, invalid },
            }) => {
                return (
                    <RadioGroup
                        value={value}
                        onValueChange={onChange}
                        onBlur={onBlur}
                        errorMessage={error?.message}
                        isInvalid={invalid}
                        {...props}
                        size="sm"
                    >
                        {options.map((option) => (
                            <CustomRadio
                                isDisabled={option.isDisabled}
                                key={option.id.toString()}
                                value={option.id.toString()}
                                {...radioProps}
                            >
                                <div className="flex flex-row gap-1 items-center">
                                    {option.icon && (
                                        <div className="px-1 text-primary-500">
                                            {option.icon}
                                        </div>
                                    )}
                                    {option.description}
                                </div>
                            </CustomRadio>
                        ))}
                    </RadioGroup>
                );
            }}
        />
    );
}

export default SelectButtonInput;
